import { ReactNode } from "react";
import { useAppSelector } from "app/lib/store/hooks";
import { Navigate } from "react-router-dom";
import { RootState } from "app/lib/store/store";

const ProtectedRedirectTo = "/";
interface RoutesProp {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: RoutesProp): JSX.Element | null => {
  const applicant = useAppSelector(
    (state: RootState) => state.loanTypesSteps.savedIds
  );
  const hasIds = Boolean(applicant && Object.keys(applicant).length);
  return hasIds ? (
    <>{children}</>
  ) : (
    <Navigate to={ProtectedRedirectTo} replace />
  );
};

export { ProtectedRoute };
